import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import './Components.css';
import {Navbar,NavbarBrand,NavLink,Nav,NavDropdown} from 'react-bootstrap';
import myphoto from './icons/myphoto.jpg';
import html5 from './icons/html-5.svg';
import css3 from './icons/css-3.svg';
import bootstrap from './icons/bootstrap.svg';
import javascript from './icons/javascript.svg';
import reactjs from './icons/react.svg';


class Home extends Component {
    constructor(props){
        super(props);
    }
    render() { 
        return ( 
            <div>
                <Navbar collapseOnSelect expand="lg" bg="dark" variant="dark" fixed="top">
                    <Navbar.Brand href="#home">
                      <img className="rounded-circle" 
                           src={myphoto} 
                           alt="my-photo" 
                           style={{width:'50px'}}/>
                        PHANINDRA
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="ml-auto">
                          <NavDropdown.Divider />
                          <Nav.Link href="#home">HOME</Nav.Link>
                          <Nav.Link href="#mywork">MY WORK</Nav.Link>
                          <Nav.Link href="#resources">RESOURCES</Nav.Link>
                          <Nav.Link href="#contacts">CONTACTS</Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </Navbar>
                <section id="home">
                    <div className="home">
                        <div className="container mt-5 text-dark">

                            <div className="row mt-5">
                                <div className="col-md-5 d-flex justify-content-center">
                                   <img className="bg-img img-thumbnail" src={myphoto} />
                                </div>
                                <div className="col-md-6 d-flex justify-content-center align-items-center px-4">
                                   <div className="row text-center">
                                        <h1 className="text-white display-4 font-weight-bold p-1">
                                           Hi, I am <br/> Phanindra Reddy
                                        </h1>
                                       
                                        <h1 className="caption font-weight-normal  px-3 mx-2">
                                           Front-End Engineer
                                        </h1>
                                    </div>
                                </div>
                            </div>

                            <div className="row justify-content-center">
                              <div className="col-md-12 col-lg-4 my-2 py-md-3">
                                <a
                                  className="btn  btn-outline-primary bg-primary border text-white p-3 w-50"
                                  href="" target="_blank"
                                >
                                  Resume
                                </a>
                               </div>
                            </div>

                            <div className="row text-center mt-4">
                              <div className="container ">
                                <div className="row justify-content-center">
                                  <div className="col-md-10 text-white">
                                    <p className="font-weight-bold lead">
                                        An aspiring Full Stack Web Developer, and a Self-Taught student.
                                        FreeCodeCamp helped a lot to shape my carrer.Youtube channels like
                                        Traversy Media, Dev Moutain and many more changed the way i code in my 
                                        journey.Self learning made to accept any challenge in my life. finally Never GIVE UP! 
                                    </p>
                                    <hr />
                                        <h2 className="font-weight-bold mt-3">Tech Stack</h2>
                                    <hr />

                                    <div className="row justify-content-around">
                                        <img
                                          src={html5}
                                          width="120px"
                                          className="img-fluid p-3"
                                          alt=""
                                        />
                                        <img
                                          src={css3}
                                          width="120px"
                                          className="img-fluid p-3"
                                          alt=""
                                       />
                                       <img
                                          src={bootstrap}
                                          width="120px"
                                          className="img-fluid p-3"
                                          alt=""
                                       />
                                       <img
                                          src={javascript}
                                          width="120px"
                                          className="img-fluid p-3"
                                          alt=""
                                       />
                                       <img
                                          src={reactjs}
                                          width="120px"
                                          className="img-fluid p-3"
                                          alt=""
                                       />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
         );
    }
}
 
export default Home;

